export default __webpack_public_path__ + "static/media/load.6782d9ce.svg";